import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import Heading from '../../Components/sectionHeading'
import rocket from '../../images/raodmap_rocket.png'
import roadimg from '../../images/roadmapimg.png'
import roadmap_moon from '../../images/roadmap_moon.png'
import mobile from '../../images/mobile.png'



const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(22),
      flexBasis: '100%',
      flexShrink: 0,
      color: '#fff'
    },
    mainAcc: {
      background: 'radial-gradient(at top left,#030921,#030921,#171e3b)',
      borderRadius: '10px !important'
    },
    mainheading: {
      backgroundColor: '#181f3c',
      borderRadius: 10
    },
  }));

const Roadmap = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div id="roadmap" className="pt-5">
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          className="pb-5 mt-5 mt-md-0"
        >
          <Grid
              xs={12}
              className="mb-4"
          >
            <Heading 
                title="RoadMap"
                // subtitle="Timeline"
            />
          </Grid>
          <div className="Fmm---Roadmap-container d-sm-none">
            <img src={mobile} className="Fmm---main-img" />
          </div>

          <div className="Fmm---Roadmap-container d-none d-sm-flex">
            <img src={roadimg} className="Fmm---main-img" />
            <img src={roadmap_moon} className="img-fluid Fmm---moon-img" />
            <div className="rocket">
              <img src={rocket} className="Fmm---rocket-img" />
            </div>
          </div>
          {/* <img src={roadimg} alt="Header Image" className="img-fluid mx-auto" style={{width: '90%',
    height: 'auto'}} /> */}


        </Grid>
      </Container>
    </div>
  );
}

export default Roadmap;
